export const profile = {
  name: 'Gabriel Huayamabe',
  title: {
    en: 'Systems Engineer | Senior Full-Stack Developer',
    es: 'Ingeniero en Sistemas | Desarrollador Full-Stack Senior'
  },
  role: {
    en: 'Senior Full-Stack Developer',
    es: 'Desarrollador Full-Stack Senior'
  },
  location: 'Guayaquil, Ecuador',
  phone: '+593 99 440 5445',
  email: 'ghuayamabe89@gmail.com',
  linkedin: 'https://www.linkedin.com/in/gabriel-huayamabe-aba907120/',
  years: '11+',
  summary: {
    en: 'Systems Engineer and Senior Full-Stack Developer with 11+ years of experience across the full software development lifecycle. My current focus is PHP on the back end, React with TypeScript and JavaScript on the front end, and PostgreSQL and SQL for databases — with AI tools like Claude (Anthropic) integrated into my daily workflow.',
    es: 'Ingeniero en Sistemas y Desarrollador Full-Stack Senior con más de 11 años de experiencia en todo el ciclo de vida del desarrollo de software. Mi enfoque actual es PHP en el back end, React con TypeScript y JavaScript en el front end y PostgreSQL y SQL para bases de datos, integrando herramientas de IA como Claude (Anthropic) en mi flujo de trabajo diario.'
  },
  about: {
    en: 'I use Claude (Anthropic) to optimize and refactor code, accelerate code reviews, and strengthen QA through test-case generation and early bug detection. Self-taught professional with a proven track record of rapidly adopting emerging technologies, designing efficient systems, and delivering high-quality code. Experienced in leading technical projects, applying Scrum, and maintaining high-traffic e-commerce platforms for global brands across Latin America.',
    es: 'Uso Claude (Anthropic) para optimizar y refactorizar código, agilizar las revisiones de código y fortalecer el QA mediante la generación de casos de prueba y la detección temprana de errores. Profesional autodidacta con trayectoria comprobada en la adopción rápida de nuevas tecnologías, el diseño de sistemas eficientes y la entrega de código de alta calidad. Experiencia liderando proyectos técnicos, aplicando Scrum y manteniendo plataformas de e-commerce de alto tráfico para marcas globales en Latinoamérica.'
  },
  availability: {
    en: 'Available: Remote, Hybrid or On-site',
    es: 'Disponible: remoto, híbrido o presencial'
  }
}
